var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMagnifyingGlass = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.242 10.843a6.501 6.501 0 0 0-9.84-8.437 6.501 6.501 0 0 0 8.444 9.835h-.002c.03.04.063.078.099.115l3.85 3.85a1 1 0 1 0 1.414-1.413l-3.85-3.85a1.012 1.012 0 0 0-.114-.1ZM12.5 7a5.501 5.501 0 1 1-11.002 0A5.501 5.501 0 0 1 12.5 7Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMagnifyingGlass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/magnifyingGlass.35d47c6426ca1d657d669a13b76081f1.svg";